import React from 'react'
import Raven from 'raven-js';

import {
  APIError, InternalServerError, ClientError, BadRequest,
  PermissionDenied, NotFound
} from 'django-rest-react';
import type { SentryConfig, HasLoggedIn, GetUsername } from './common';

type SeverityLevel = "fatal" | "error" | "warning" | "info" | "debug";



export const parseErrors: <T extends HasLoggedIn, >(err: Error, login: T, get_username: GetUsername<T>, sentry_config: SentryConfig) => {
  block: React.ReactNode,
  dettaglio: React.ReactNode,
} = (err, login, get_username, sentry_config) => {
  let block; let dettaglio;
  let error_level = "error";
  if (err instanceof APIError) {
    if (err instanceof PermissionDenied) {
      block = "403: Permesso negato";
      error_level = "warning";
    } else if (err instanceof InternalServerError) {
      block = "Internal Server error";
    } else if (err instanceof BadRequest ||
      err instanceof ClientError) {
      block = "400: Bad request";
    } else if (err instanceof NotFound) {
      block = "404: Oggetto non trovato";
    } else {
      block = "Errore generico";
    }
    dettaglio = <p>Errore</p>;
    if (err.err_detail?.detail) {
      dettaglio = <p>{err.err_detail.detail}</p>;
    } else if (err.message) {
      dettaglio = <p>{JSON.stringify(err.message)}</p>;
    }
  } else {
    block = "L'applicazione è crashata";
    dettaglio = <pre>{err.stack}</pre>
    console.trace()
  }
  if (sentry_config.use_sentry) {
    const username = login.logged_in ?
      get_username(login) :
      "Anonymous";
    Raven.setUserContext({
      username,
    });
    Raven.captureException(err, {
      level: error_level as SeverityLevel,
    });
  }
  return {
    block: block,
    dettaglio: dettaglio,
  }
}
